import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { twMerge } from "tailwind-merge";
export const ErrorHeader = ({ title, subtitle, className }) => {
    return (_jsxs("div", { className: twMerge("flex flex-col justify-between gap-1 font-title", className), children: [_jsx("h1", { className: "font-normal text-secondary text-xl", children: title ?? "Something went wrong" }), _jsx("div", { className: "font-text text-base text-tertiary", children: subtitle ?? "An error occurred while we were getting this page ready." })] }));
};
